import { GraphqlResultPageInfo } from '@shared/models';
import { JupiterStateModel, LabelSlot } from './types';

export const defaultPropertyAddFormDefinition = {
  fields: [
    { name: 'name', isRequired: false, isRemovable: false },
    { name: 'property_type_id', isRequired: false, isRemovable: true },
    { name: 'template_id', isRequired: true, isRemovable: false },
    { name: 'cff_address', isRequired: true, isRemovable: false },
  ],
};

export const DEFAULT_PAGE_INFO: GraphqlResultPageInfo = {
  endCursor: '',
  filteredCount: 0,
  hasNextPage: false,
  hasPreviousPage: false,
  startCursor: '',
  totalCount: 0,
  currentPage: 1,
  pageSize: 20,
};

export const defaultStateValue: JupiterStateModel = {
  views: [],
  view: null,
  scheduledExports: [],
  activeExportScheduleId: null,
  relatedToKey: null,
  relatedToObject: null,
  isCustom: null,
  context: null,
  data: {
    rows: [],
    pageInfo: DEFAULT_PAGE_INFO,
  },
  entity: null,
  transientEntity: null, // note to myself, I think this could be called only transient and act as a dictionary - like the transient prop
  transient: null,
  slots: {
    permissions: {},
    labels: LabelSlot,
  },
  featureSupport: {
    homeActions: {
      actions: {
        add: false,
        export: false,
        importVCard: false,
        createContactAssociation: false,
        manageView: false,
        viewList: false,
        linkDeal: false,
        groupBy: false,
      },
    },
    groupedTable: false,
    bulkActions: {
      enabled: false,
      actions: {
        deleteRows: false,
        updateTags: false,
        createDealOrPortfolio: false,
      },
    },
    gridActions: {
      enabled: false,
      actions: {
        logCall: false,
        logMeeting: false,
        logSocialMedia: false,
        edit: false,
        delete: false,
        openDetails: false,
      },
    },
    tags: {
      enabled: false,
    },
    detailsMainTabs: {
      backButton: false,
      avatar: false,
      details: false,
      files: false,
      notes: false,
      activities: false,
      engagements: false,
      tasks: false,
      linkedObjects: false,
      deals: false,
      leases: false,
      nearby: false,
      contacts: false,
      dispositions: false,
      loanQuotes: false,
      financials: false,
      contextMenu: {
        enabled: false,
        actions: {
          layoutManager: false,
          delete: false,
          changeLayout: false,
          duplicate: false,
          generateMergeDocument: false,
          merge: false,
          sendEmail: false,
          summary: false,
        },
      },
    },
    panels: {
      'crm-table-panel': false,
      'crm-action-panel': false,
      form: false,
      comments: false,
      table: false,
      images: false,
      matrix: false,
      activity: false,
      engagements: false,
      map: false,
      chart: false,
      financial_report: false,
      roles: false,
      contacts: false,
      unit_lease: false,
      unit_form: false,
      mailbox: false,
    },
  },
  engagements: null,
  deals: null,
  properties: null,
  loanQuotes: null,
  contacts: null,
  propertyUnits: null,
  backUrl: null,
  global: {
    isBusy: false,
    isSearching: false,
  },
};
